<template>
  <fieldset class="m-0 p-0 border-0" :class="typeClass">
    <legend
      v-if="legend"
      class="mb-8 flex flex-col text-text-primary"
      :class="ledgendClass"
    >
      {{ legend }}
    </legend>
    <legend v-if="extraLegend" class="mb-8 heading-xxs text-text-primary">
      {{ extraLegend }}
    </legend>
    <legend v-if="extraLegendSecond" class="mb-8 body-md text-text-primary">
      {{ extraLegendSecond }}
    </legend>

    <div class="content relative flex flex-col gap-16" :class="columnClass">
      <slot> </slot>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
interface Props {
  extraLegend?: string;
  extraLegendSecond?: string;
  legend?: string;
  ledgendClass?: string;
  typeClass?: 'color' | 'product-page' | 'default';
  columnClass?: 'one-column';
}

withDefaults(defineProps<Props>(), {
  extraLegend: '',
  extraLegendSecond: '',
  legend: '',
  typeClass: undefined,
  columnClass: undefined,
  ledgendClass: 'heading-xs',
});
</script>

<style scoped lang="scss">
.color {
  width: fit-content;
  .content {
    width: fit-content;
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
    &:has(> input:focus) {
      @apply outline outline-2 outline-border-highlight outline-offset-0 rounded-xs;
    }
  }
}

.default {
  width: 100%;
  .content {
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
    display: grid;
    row-gap: 8px;
    &.one-column {
      grid-template-columns: 1fr;
    }
  }
}

.product-page {
  width: 100%;
  .content {
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
    display: grid;
    row-gap: 8px;
    &.one-column {
      grid-template-columns: 1fr;
    }
  }
}
</style>
